const constants = require('@/util/constants')
require('./config')

/**
 * 取消/启用此客服账号-公众号离线消息推送
 * flag = true: 允许推送
 * flag = false: 取消推送
 */
export function switchMpPush(uid, flag, successcb, failedcb) {
    axios.get('/api/push/mp/switch', {
        params: {
            'uid': uid,
            'flag': flag,
            'client': constants.HTTP_CLIENT
        }
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

// 查询此客服账号 - 公众号离线消息推送状态
export function getMpPushStatus(uid, successcb, failedcb) {
    axios.get('/api/push/mp/status', {
        params: {
            'uid': uid,
            'client': constants.HTTP_CLIENT
        }
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}
